import { Outlet } from "react-router-dom"
import NavbarLayout from "./NavbarLayout"
import { useState } from "react";
export default function Navbar() {

    const [phoneNumber, setPhoneNumber] = useState("");
    const [showNavbar, setShowNavbar] = useState(false);

    return (
        <>
            <NavbarLayout phoneNumber={phoneNumber} showNavbar={showNavbar} />
            <Outlet  context={{
          setShowNavbar,
          setPhoneNumber
        }} />
        </>
    )

}